import React, { useState, useCallback, useEffect } from 'react'
import * as Yup from 'yup'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoLoader from '../../components/FormComponents/NeoLoader'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import { useHistory } from 'react-router-dom'
import { Form, Formik } from 'formik'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import { useTranslation } from 'react-i18next'
import { REQUESTS_KEYS, VALIDATION_MESSAGES } from '../../utils/translation-constants'
import SendToMobileService from '../../services/send-to-mobile.service'
import AccountsService from '../../services/accounts.service'
import NumberFormat from 'react-number-format'

import LayoutWithAccountCard from '../../layout/Layout/layout-account-card'

import { ACCOUNT_SUB_MENUS } from '../../layout/Layout/menu-names'
import BackArrow from 'custom/assets/common-icons/back-arrow.svg'

const parentMenus = ACCOUNT_SUB_MENUS.filter((ele) => ele.key !== 'SEND_TO_MOBILE')
const menuDetails = ACCOUNT_SUB_MENUS.filter((ele) => ele.key === 'SEND_TO_MOBILE')[0]

export default function SendToMobile() {
  const [otp, setOtp] = useState('')
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const history = useHistory()
  const { t } = useTranslation()
  // const accounts = useSelector(accountsSelector)
  const [formData, setFormData] = useState({})
  const [terms, setTerms] = useState('')
  const [wallet, setWalletList] = useState([])
  const [accountList, setAccountList] = useState([])

  const [serId, setSerId] = useState('')
  const [valid, setValid] = useState('')

  // let list=walletList()
  const [verifyResponse, setVerifyResponse] = useState(false)

  const fetchAccounts = useCallback(async () => {
    const response = await AccountsService.getAllAccounts()
    setAccountList(response.accountSummaryList)
  }, [])

  const getWalletList = useCallback(async () => {
    const response = await SendToMobileService.walletList()
    setWalletList(response)
    setStage(1)
  }, [])

  useEffect(() => {
    getWalletList()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return <NeoLoader />
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP
            loading={loading}
            otp={otp}
            setOTP={setOtp}
            onSubmit={confirmSendToMobileTransfer}
          />
        )
      case 4:
        return <NeoSuccess message={message} onClick={() => setStage(1)} />
      default:
        return <NeoLoader />
    }
  }

  const SchemaSendtoMobile = Yup.object().shape({
    serviceId: Yup.string().required(t(VALIDATION_MESSAGES.REQUIRED)),
    mobileNumber: Yup.string()
      .required(t(VALIDATION_MESSAGES.REQUIRED))
      .matches(new RegExp(serId), t(VALIDATION_MESSAGES.MOBILE_NUMBER)),
    remarks: Yup.string(),
    transferAmount: Yup.string()
      .matches(/^(\d+|\d{1,3}(,\d{3})*)(\.\d+)?$/, t(VALIDATION_MESSAGES.NUMBERS))
      .required(t(VALIDATION_MESSAGES.REQUIRED)),
  })

  const submitSendToMobile = useCallback(
    async (data) => {
      try {
        setLoading(true)
        setFormData(data)
        const account = accountList.filter((v) => v.accountNo === data.accountNumber)[0]
        // if (+data.transferAmount < 1) {
        //   setMessage('Enter amount greater than 0')
        //   showModal()
        //   return
        // }
        // if (account.avlBal < +data.transferAmount) {
        //   setMessage('Insufficient Balance')
        //   showModal()
        //   return
        // }
        const servId = wallet.filter((v) => v.walletName === data.serviceId)[0]
        const response = await SendToMobileService.verifyTransfer({
          accountBranch: account.brnCode,
          accountCurrency: account.currency,
          accountNumber: account.accountNo,
          receiverMobileNo: data.mobileNumber,
          remarks: data.remarks,
          transferAmount: data.transferAmount,
          serviceId: servId.serviceId,
        })
        setVerifyResponse(response)
        setStage(2)
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    },
    [accountList, wallet],
  )

  // const confirmSend = useCallback(() => {
  //   try {
  //     setLoading(true)
  //     setStage(3)
  //     setLoading(false)
  //   } catch (error) {
  //     setMessage(error.message)
  //     showModal()
  //   }
  // }, [])

  // const fetchTerms = useCallback(async () => {
  //   try {
  //     setLoading(true)
  //     const response = await getTerms()
  //     setTerms(response.termsCondition[0].message)
  //     setLoading(false)
  //   } catch (error) {
  //     setLoading(false)
  //     setMessage(error.message)
  //     showModal()
  //   }
  // })

  const confirmSendToMobileTransfer = useCallback(async () => {
    try {
      setLoading(true)
      const account = accountList.filter((v) => v.accountNo === formData.accountNumber)[0]
      const servId = wallet.filter((v) => v.walletName === formData.serviceId)[0]
      const response = await SendToMobileService.confirmTransfer({
        accountBranch: account.brnCode,
        accountCurrency: account.currency,
        accountNumber: account.accountNo,
        receiverMobileNo: formData.mobileNumber,
        remarks: formData.remarks,
        transferAmount: formData.transferAmount,
        destinationAccount: verifyResponse.destAcc,
        destinationAccountName: verifyResponse.destAccName,
        destinationBranch: verifyResponse.destAccBranch,
        destinationCurrency: verifyResponse.destAccCur,
        otp: verifyResponse.otpEnable ? otp : '0000',
        randomKey: verifyResponse.randomKey,
        serviceId: servId.serviceId,
      })
      setMessage(response.message)
      setStage(4)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }, [otp, formData, accountList, wallet])

  function renderForm() {
    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={{
            mobileNumber: '',
            amount: '',
            remarks: '',
            serviceId: '',
          }}
          validationSchema={SchemaSendtoMobile}
          onSubmit={submitSendToMobile}>
          {({ errors, touched, handleChange, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <NeoInput
                      mode='select'
                      text='Service ID'
                      name='serviceId'
                      onChange={(e) => {
                        const servId = wallet.filter((v) => v.walletName === e.target.value)[0]
                        setSerId(servId.regexVal)
                        handleChange(e)
                      }}
                      list={wallet}
                      keyValue='walletName'
                    />
                    <InputError text={errors.serviceId} touched={touched.serviceId} />
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <NeoInput
                      mode='amount'
                      text='Amount'
                      onChange={(values) => {
                        setFieldValue('transferAmount', values.value)
                      }}
                      name='amount'
                    />
                    <InputError touched={touched.transferAmount} text={errors.transferAmount} />
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <NeoInput
                      text='Receiver Mobile Number'
                      onChange={(e) => {
                        const re = /^[0-9\b]+$/
                        if (e.target.value === '' || re.test(e.target.value)) {
                          setFieldValue('mobileNumber', e.target.value)
                        }
                      }}
                      type='number'
                      name='mobileNumber'
                    />
                    <InputError touched={touched.mobileNumber} text={errors.mobileNumber} />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <NeoInput text='Remarks' onChange={handleChange} name='remarks' />
                    <InputError touched={touched.remarks} text={errors.remarks} />
                  </div>
                </div>
              </div>
              <div className='mt-5'>
                {loading ? <NeoLoader /> : <NeoButton type='submit' text='Next' />}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column'>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Account Number</h6>
          <h6>{formData.accountNumber}</h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Transfer Amount</h6>
          <h6>
            <NumberFormat
              value={formData.transferAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Charges</h6>
          <h6>
            <NumberFormat
              value={verifyResponse.charges}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Service ID</h6>
          <h6>{formData.serviceId}</h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Reciever Mobile Number</h6>
          <h6>{formData.mobileNumber}</h6>
        </div>
        <div className='my-3 d-flex justify-content-between align-items-center'>
          <h6 className='text-gray'>Remarks</h6>
          <h6>{formData.remarks}</h6>
        </div>
        <div className='mt-5 ml-auto px-0 col-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CONFIRM)}
              onClick={() => {
                verifyResponse.otpEnable ? setStage(3) : confirmSendToMobileTransfer()
              }}
            />
          )}
        </div>
      </div>
    )
  }

  const stageCallback = useCallback(() => {
    const startStage = 1
    if (stage === startStage) {
      history.goBack()
    } else if (stage - 1 >= startStage) {
      const newStage = stage - 1
      setStage(newStage)
    }
  }, [stage])

  function renderBackButton() {
    return (
      <div
        className='mx-2 mb-4 cursor-pointer font-weight-600'
        style={{ fontSize: 12, width: 'fit-content' }}
        onClick={stageCallback}>
        <img className='mr-4' src={BackArrow} />
        Back to Form
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      title={'Accounts'}
      description={'Account Description'}
      parentMenuList={parentMenus}
      icon={menuDetails.icon}>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={menuDetails.icon} alt='statement icon' />
          </div>
          <div>
            <span className='font-weight-bold'>{t(menuDetails.title)}</span>
            <span className='header-title-section'>
              <p>{t(menuDetails.desc)}</p>
            </span>
          </div>
        </div>
        <div className='col-5 text-right'></div>
      </div>

      {stage !== 1 && stage !== 0 && stage !== 4 && renderBackButton()}
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
